module.exports = __webpack_public_path__ + "img/Car.c8e84c7d.png";